"use client"

import type React from "react"
import { useRef, useEffect } from "react"

interface HtmlRendererProps {
    htmlString: string
}

const HtmlRenderer: React.FC<HtmlRendererProps> = ({ htmlString }) => {
    const iframeRef = useRef<HTMLIFrameElement>(null)

    useEffect(() => {
        if (iframeRef.current) {
            const iframe = iframeRef.current
            iframe.srcdoc = htmlString
        }
    }, [htmlString])

    return (
        <iframe
            ref={iframeRef}
            title="Rendered HTML Content"
            sandbox="allow-scripts allow-same-origin"
            style={{
                width: "100%",
                height: "100%",
                overflow: "hidden", // İç iframe'in kendi kaydırma çubuklarını gizle
            }}
        />
    )
}

export default HtmlRenderer
